// extracted by mini-css-extract-plugin
export default {"wrapper":"cargo-badge_wrapper__9AVv4"};